import { useGetLezsQuery } from "@evr/apis/lez/hooks/useGetLezsQuery";
import { TableSearch } from "@evr/components/Table";
import { TablePagination } from "@evr/components/Table/TablePagination";
import { Dialogs } from "@evr/constant";
import { useAppDispatch, useAppSelector } from "@evr/hooks/reduxHooks";
import { openDialog } from "@evr/store/slices/dialog";
import { clearLezSearchColumn, selectLezsPagination, setLezPageIndex, setLezSearchColumn } from "@evr/store/slices/lez";
import { SearchColumn } from "@evr/types";
import { CircleLoading } from "@evr/ui/CircleLoading";
import { DialogSyncHeaderButton } from "@evr/ui/Dialog";
import { Flex } from "@evr/ui/FlexBox";
import { IconButton } from "@evr/ui/IconButton";
import { TableWrapper } from "@evr/ui/Table";
import { Typography } from "@evr/ui/Typography";

import { LezTable } from "./LezTable";
import { lezTableColumns } from "./lezTableColumns";


export const LezWindow = () => {
  const dispatch = useAppDispatch();
  const { search, pageIndex } = useAppSelector(selectLezsPagination);
  const { data, isFetching, isError, refetch } = useGetLezsQuery();

  const handleRefetchData = () => refetch();
  const handleClearSearchValue = (column: string) => dispatch(clearLezSearchColumn(column));
  const handleChangeSearchValue = (item: SearchColumn) => dispatch(setLezSearchColumn(item));
  const handleChangePageIndex = (page: number) => dispatch(setLezPageIndex(page));
  const handleOpenLEZDialog = () => dispatch(openDialog({ type: Dialogs.ADD_LEZ }));

  const Actions = (
    <Flex>
      <IconButton icon="plus" color="white" size={1.2} title="Add LEZ" onClick={handleOpenLEZDialog} />
      <DialogSyncHeaderButton onClick={handleRefetchData} loading={isFetching} />
    </Flex>
  );

  return (
    <>
      <TableSearch
        search={search}
        Actions={Actions}
        columns={lezTableColumns}
        changeSearchValue={handleChangeSearchValue}
        clearSearchValue={handleClearSearchValue}
      />
      <TableWrapper>
        {isFetching && <CircleLoading color="primary" size={5} blurBackground />}
        {data ? (
          <LezTable lezs={data.resources} />
        ) : (
          <Flex height="100%" width="100%">
            {isError && <Typography>Something went wrong. Please try again.</Typography>}
          </Flex>
        )}

        {data && data.resources.length === 0 && (
          <Typography textAlign="center" as="div">
            You have no LEZ
          </Typography>
        )}
      </TableWrapper>
      <TablePagination totalPages={data?.totalPages} pageIndex={pageIndex} action={handleChangePageIndex} />
    </>
  );
};
